import '../../styles/pages/spring-summer-2025/the-talent-behind-disney-communications.scss'
import React from 'react'
import Layout from '../../components/layout'
import { Helmet } from 'react-helmet'
import MoreStories from '../../components/spring-summer-2025-stories/more-stories'
import HeroImage from '../../images/spring-summer-2025/the-talent-behind-disney-communications/talent-behind-disney-communications-header-image.jpg'
import socialBanner from '../../images/spring-summer-2025/social-banners/the-talent-behind-disney-communications-social.jpg'
import ImageOne from '../../images/spring-summer-2025/the-talent-behind-disney-communications/image01-800.jpg'
import ImageTwo from '../../images/spring-summer-2025/the-talent-behind-disney-communications/image02-800.jpg'
import ImageThree from '../../images/spring-summer-2025/the-talent-behind-disney-communications/image03-800.jpg'
import ImageFour from '../../images/spring-summer-2025/the-talent-behind-disney-communications/image04-800.jpg'
import ImageFive from '../../images/spring-summer-2025/the-talent-behind-disney-communications/image06-800.jpg'

export default class Index extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        var pageTitle = 'The Talent Behind Disney Communications'
        var pageDesc = 'Cal State Fullerton alumni make up a third of the communications and public affairs team at Disneyland Resort.'
        var slug = 'the-talent-behind-disney-communications'

        var heroStyles = {
            backgroundImage: `url(${HeroImage})`,
            backgroundColor: '#104977'
        }

        /*const photos = [
            {
                src: exampleImage1,
                width: 800,
                height: 533,
                alt: '',
                title: '',
            },
            {
                src: exampleImage2,
                width: 533,
                height: 800,
                alt: '',
                title: '',
            },
        ]*/

        return (
            <Layout headerStyle="white" locationInfo={this.props.location} issue="spring-summer-2025">
                <Helmet>
                    <title>{pageTitle}</title>
                    <body className={`spring-summer-2025 ${slug}`} />

                    <meta name="description" content={pageDesc} />

                    {/* Schema.org markup for Google+ */}
                    <meta itemprop="name" content={pageTitle} />
                    <meta itemprop="description" content={pageDesc} />
                    <meta itemprop="image" content={socialBanner} />

                    {/* Twitter Card data */}
                    <meta name="twitter:title" content={pageTitle} />
                    <meta name="twitter:description" content={pageDesc} />
                    <meta name="twitter:image:src" content={socialBanner} />

                    {/* Open Graph data */}
                    <meta property="og:title" content={pageTitle} />
                    <meta property="og:image" content={socialBanner} />
                    <meta property="og:image:alt" content={pageTitle} />
                    <meta property="og:description" content={pageDesc} />
                </Helmet>
                <div className="backgroundHeader"></div>
                <div className="hero story animated fadeIn" style={heroStyles}>
                    <div className="text">
                        <h1 className="animated fadeInDown delay-1s">
                            The{' '}
                            <span className="emphasis">
                                Talent
                                <br /> Behind Disney
                            </span>
                            <br />
                            Communications
                        </h1>
                        <span className="animated fadeInDown delay-1s byline">By Taylor Arrey</span>
                        <p className="animated fadeInDown delay-2s">
                            Cal State Fullerton alumni make up a third of the communications and public affairs team at Disneyland Resort.
                        </p>
                    </div>
                </div>
                <article className="wrap medium">
                    <div className="small wrap">
                        <p>
                            <span className="intro-text"> For Suzi Brown, working with the Disneyland Resort</span> communications and public affairs
                            team is a lot like suiting up with “The Incredibles.”
                        </p>
                        <p>
                            “Like Mr. and Mrs. Incredible, Edna Mode and the kids — we are strong leaders, flexible, adaptable, efficient, cool under
                            pressure, creative and prepared. Our team of superheroes uses its powers to tell Disney stories and protect and enhance
                            our reputation,” says Brown, vice president of communications at Disneyland Resort.
                        </p>
                    </div>
                    <div className="image-block">
                        <figure style={{ transform: 'rotate(5deg)' }}>
                            <img src={ImageOne} alt='Group of students and staff wearing CSUF apparel posing together indoors in front of a red display with a small vehicle prop and a ‘Ride the Skyway’ sign.' />
                            <figcaption>
                                <p>
                                    <strong>Back row, from left to right:</strong> Kyleigh Johnson ’16; Sasha Azoqa ’15, ’22; Sabrina Sanchez ’22;
                                    Gabe Valenzuela ’23; Sarah Garreton ’24; Amanda Arreguin ’21; Suzi Brown ’88; and Jessica Pineda ’15
                                </p>
                                <p>
                                    <strong>Front row, from left to right:</strong> Serene Soto ’23; Karalee Darnell ’04, ’06; Christopher Ho ’20; and
                                    Miranda Bravo ’24
                                    <br />
                                    <small>(Courtesy of Disneyland Resort)</small>
                                </p>
                            </figcaption>
                        </figure>

                        <figure style={{ transform: 'rotate(-2deg)' }}>
                            <img src={ImageTwo} alt='Woman wearing a navy blazer and striped shirt with a name badge reading ‘Suzi,’ smiling while seated indoors.' />
                            <figcaption>
                                <p>
                                    <strong style={{ color: '#4c6fac', fontWeight: '900', fontSize: '150%' }}>Suzi Brown ’88</strong>
                                    <br />
                                    Vice president of communications at Disneyland Resort <br />
                                    <small>(Courtesy of Christian Thompson/Disneyland Resort)</small>
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                    <div className="small wrap">
                        <p>
                            Beyond their storytelling strength, Brown says there’s another superpower that many people on the team possess: They’re
                            Titans.
                        </p>
                        <p>
                            Of the 60-person communications and public affairs team at Disneyland Resort, 20 are Cal State Fullerton alumni, including
                            Brown, who graduated with a bachelor’s degree in communications-public relations in 1988 and launched her career as an
                            intern for the resort.
                        </p>
                        <p>
                            Brown says what sets CSUF graduates apart is the hands-on training they receive in the{' '}
                            <a href="https://communications.fullerton.edu/" target="_blank">
                                College of Communications
                            </a>
                            . In addition to completing internships, communications students build their portfolios through student-run media outlets
                            and gain experience working with companies who partner with campus organizations.
                        </p>
                        <p>
                            “It has been our experience that CSUF grads are talented, professional and well-prepared for the workplace,” says Brown.
                        </p>
                        <p>
                            The Disneyland Resort communications and public affairs team oversees government and public relations, internal, external
                            and executive communications, public and external affairs, and corporate social responsibility.
                        </p>
                        <p>
                            “We have alumni at every level of our team, from interns and managers to executives, who represent every decade from the
                            1980s to the 2020s,” says Brown.
                        </p>
                        <div className="align-wide">
                            <blockquote>
                                <p>
                                    "CSUF grads are <br />
                                    <strong>talented, professional and well-prepared</strong> for the workplace."
                                </p>
                                <cite>Suzi Brown</cite>
                            </blockquote>
                        </div>

                        <h2>‘Always a Part of the Titan Family’</h2>

                        <p>The Titan legacy at Disneyland Resort is part of the magic that Gabe Valenzuela experiences every day.</p>
                        <p>
                            After graduating in 2023, Valenzuela landed an internship with the resort’s internal communications team before he was
                            promoted to a communications associate, and later, an internal communications specialist.
                        </p>
                        <p>
                            “There’s a shared sense of pride knowing we all came from similar academic upbringings and found our way to Disneyland
                            Resort. It brings our team closer together and serves as a constant reminder that I’ll always be a part of the Titan
                            family,” says Valenzuela ’23 (B.A. communications-entertainment studies).
                        </p>
                        <p>
                            In his current role, Valenzuela helps tell cast members’ stories, capturing Disney’s history and culture through the lens
                            of its employees. Valenzuela has penned multiple stories for the Disney Parks Blog, including a feature about cast
                            costumes for one of Disneyland’s newest attractions, Tiana’s Bayou Adventure.
                        </p>
                        <p>
                            Valenzuela and his team also are responsible for fostering employee engagement and keeping cast members updated with
                            company news.
                        </p>

                        <figure>
                            <img src={ImageThree} style={{ borderRadius: '30px' }} alt='Small group of students seated in a colorful lounge area having a discussion with a woman in a blazer; several hold branded cups.' />
                            <figcaption>
                                <p>
                                    Disneyland Resort internal communications team members Sasha Azoqa ’15, ’22; Gabe Valenzuela ’23; Ross Hunter-Boak
                                    ’25; and Andrea Agustin ’24, ’25 with Suzi Brown ’88
                                    <br />
                                    <small>(Courtesy of Christian Thompson/Disneyland Resort)</small>
                                </p>
                            </figcaption>
                        </figure>

                        <p>
                            He likes to think of his team as Disneyland Resort’s very own Jiminy Cricket: “Just as Jiminy helps Pinocchio stay on the
                            right path, we’re that steady guide for our cast members, making sure they are informed and ready to support guests day in
                            and day out.”
                        </p>
                        <p>Like Brown, Valenzuela credits CSUF for preparing him to succeed and grow in his Disney career.</p>
                        <p>
                            “The coursework pushed me to be organized, detail-oriented and strategic — skills I use every single day. From
                            writing-intensive classes to collaborative projects, I constantly found myself challenged in the best way at CSUF.”
                        </p>

                        <p>
                            Beyond academics, Valenzuela says that his career trajectory would not have been possible without student organizations
                            like the Entertainment & Tourism Club, where he networked with industry leaders and developed skills that are crucial to
                            his work, such as public speaking, project management and financial planning.
                        </p>
                        <p>
                            “CSUF didn’t just prepare me for the professional world — it helped me discover who I wanted to be in that world. The
                            values of collaboration, resilience and creative thinking that were instilled in me at CSUF are the same ones I carry into
                            my work every day,” says Valenzuela.
                        </p>

                        <h2>Training a New Generation of Communicators</h2>

                        <p>
                            When she’s not collaborating with Titans to share the wonder of Disney, Brown is training the next generation of CSUF
                            communicators as a lecturer in the Department of Communications.
                        </p>
                        <p>
                            Brown’s decision to return to her alma mater as an educator was inspired by the people who had a monumental impact on her
                            career journey: “I had wonderful professors and advisers who not only encouraged me and helped me stay the course, but
                            ensured that I was career ready.”
                        </p>
                    </div>
                    <div className="image-block">
                        <figure style={{ transform: 'rotate(5deg)' }}>
                            <img src={ImageFour} alt='Student posing next to a person in a Mickey Mouse costume wearing blue traditional-style attire, standing in front of a red decorative backdrop.' />
                            <figcaption>
                                <p>
                                    <strong style={{ color: '#4c6fac', fontWeight: '900', fontSize: '150%' }}>
                                        Gabe Valenzuela ’23 and Mickey Mouse{' '}
                                    </strong>

                                    <br />
                                    <small>(Courtesy of Gabe Valenzuela)</small>
                                </p>
                            </figcaption>
                        </figure>
                        <figure style={{ transform: 'rotate(-2deg)' }}>
                            <img src={ImageFive} alt='Group of students and staff posing outdoors in front of a Disneyland entrance sign, smiling and gesturing enthusiastically.' />
                            <figcaption>
                                <p>
                                    <strong>Back row, from left to right:</strong> Natalia Ramirez ’25; Ross Hunter-Boak ’25; Mackenzie Motsinger,
                                    CSUF master’s student; Gabe Valenzuela, ’23; Larry Labrado ’97; Christopher Ho ’20; Karalee Darnell ’04, ’06; and
                                    Kyleigh Johnson ’16
                                </p>
                                <p>
                                    <strong>Front row, from left to right:</strong> Andrea Agustin ’24, ’25; Miranda Bravo ’24; Eric Benitez ’17;
                                    Sasha Azoqa ’15, ’22; Suzi Brown ’88; and Jessica Sweetman ’16
                                    <br />
                                    <small>(Courtesy of Christian Thompson/Disneyland Resort)</small>
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                    <div className="small wrap">
                        <p>
                            She teaches the Entertainment Public Relations course, providing expert insights into such areas as media and talent
                            relations, special events, and crisis management.
                        </p>
                        <p>
                            Outside the classroom, Brown participates in panels and presentations to support students in CSUF’s Public Relations
                            Student Society of America, where she got her start as a student. The organization provides aspiring communicators with
                            networking opportunities and helps them hone their skills in leadership, media strategy, event planning, social media
                            management and more.
                        </p>
                        <p>
                            “My academic and professional careers have come full circle,” says Brown. “I remember sitting in the same classrooms
                            trying to envision myself in a communications role, and I find it incredibly energizing and rewarding to be able to help
                            guide and advise students on their next steps. <span class="end-mark"></span>
                        </p>
                    </div>
                </article>
                <div className="cta-banner">
                    <div className="cta-text">
                        <p>
                            <span className="cta-title">Support the College of Communications</span>
                            <br />
                            <a href="https://give.fullerton.edu/communications" target="_blank">
                                give.fullerton.edu/communications
                            </a>
                        </p>
                    </div>
                </div>
                <MoreStories slug={slug} />
            </Layout>
        )
    }
}
